import Vue from 'vue';
// @ts-ignore
import vBtn from 'vuetify/lib/components/VBtn';
import Icon from '@/components/global/Icon/index.vue';
export default Vue.extend({
    name: 'mobPositionsTableDetailItem',
    props: {
        closing: {
            type: Boolean,
            required: true
        },
        currentPrice: {
            type: Object,
            required: true
        },
        direction: {
            type: String,
            required: true
        },
        positionPrice: {
            type: Object,
            required: true
        },
        result: {
            type: Object,
            required: true
        },
        volume: {
            type: [Object, String],
            required: true
        }
    },
    render(createElement) {
        const vm = this;
        const filters = vm.$options.filters;
        const positionPrice = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.common.positionPrice')),
            createElement('span', { class: 'tableDetailsItem_value' }, filters.formatMoney(filters.formatToCurrency(vm.positionPrice, 'bnb')))
        ]);
        const volume = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.common.value')),
            createElement('span', { class: 'tableDetailsItem_value' }, vm.volume.toString())
        ]);
        const currentPrice = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.tableHeaders.currentPrice')),
            createElement('span', { class: 'tableDetailsItem_value' }, filters.formatMoney(filters.formatToCurrency(vm.currentPrice, 'bnb')))
        ]);
        const result = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.tableHeaders.result')),
            createElement('span', { class: 'tableDetailsItem_value' }, [
                createElement('Icon', {
                    props: {
                        fontSize: '12px',
                        color: +vm.result > 0 ? vm.getColor('ACCENT.GREEN_LIGHT') : vm.getColor('ACCENT.RED_LIGHT')
                    },
                    style: {
                        transform: +vm.result > 0 ? 'none' : 'rotate(180deg)'
                    }
                }, ''),
                createElement('span', {
                    style: {
                        color: +vm.result > 0 ? vm.getColor('ACCENT.GREEN_LIGHT') : vm.getColor('ACCENT.RED_LIGHT')
                    }
                }, filters.formatMoney(filters.formatToCurrency(vm.result, 'bnb')))
            ])
        ]);
        const direction = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.common.direction')),
            createElement('span', { class: 'tableDetailsItem_value' }, vm.direction)
        ]);
        const closePosition = createElement('v-btn', {
            class: 'btn btn--gradient-border--accent btn--accent mt-2 mx-3',
            style: {
                width: 'calc(100% - 24px)'
            },
            props: {
                loading: vm.closing,
                height: 32
            },
            on: {
                click: () => { vm.$emit('closePosition'); }
            }
        }, vm.$t('mainPage.tables.positions.closePosition'));
        return createElement('div', { class: 'tableDetailsItem mt-2' }, [
            positionPrice,
            volume,
            currentPrice,
            result,
            direction,
            closePosition
        ]);
    },
    components: {
        'v-btn': vBtn,
        Icon
    }
});
